import { Avatar } from '@src/atoms/Avatar';
import { Box } from '@src/atoms/Box';
import { IProduct } from '@src/models/entities';
import { classnames } from '@src/utils/classnames';
import React from 'react';

import styles from './ProductLogos.module.scss';
import { buildLogoUrl } from '@src/utils/builtLogoUrl';

interface IProps {
  products?: IProduct[];
}

export const ProductLogos = ({ products }: IProps) => {
  if (!products) return null;
  const maxVisibleLogos = 4;
  const visibleProducts = products?.slice(0, maxVisibleLogos) || [];
  const hiddenCount = products?.length > maxVisibleLogos ? products.length - maxVisibleLogos : 0;

  return (
    <Box className={styles.root}>
      {visibleProducts.map((product) => (
        //@ts-ignore
        <Avatar imageUrl={buildLogoUrl(product, true)} key={product.id} className={styles.logo} size={34} />
      ))}

      {hiddenCount > 0 && <div className={classnames(styles.logo, styles.counter)}>+{hiddenCount}</div>}
    </Box>
  );
};
